import { type FC, useState } from "react";

import { type SyncTarget } from "../repl_status";

function readSyncTargetConfig(): SyncTarget[] {
  const raw = localStorage.getItem("externalDbs");
  if (raw != null) {
    try {
      const parsed: unknown = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        const result: SyncTarget[] = [];
        for (const item of parsed) {
          const name: unknown = item?.name;
          const url: unknown = item?.url;
          if (typeof name === 'string' && typeof url === 'string') {
            result.push({ name, url });
          }
        }
        if (result.length > 0) return result;
      }
    } catch { /* ignore */ }
  }
  const oldUrl = localStorage.getItem("externalDb");
  return [{ name: "default", url: oldUrl ?? "http://user:user@127.0.0.1:5984/inv6" }];
}

export const ReplConfig: FC = () => {
  const [targets, setTargets] = useState<SyncTarget[]>(readSyncTargetConfig);
  const [saved, setSaved] = useState(false);

  const update = (i: number, field: 'name' | 'url', value: string) => {
    setSaved(false);
    setTargets(prev => prev.map((t, j) => j === i ? { ...t, [field]: value } : t));
  };
  const remove = (i: number) => {
    setSaved(false);
    setTargets(prev => prev.filter((_, j) => j !== i));
  };
  const add = () => {
    setSaved(false);
    setTargets(prev => [...prev, { name: "", url: "" }]);
  };
  const save = () => {
    localStorage.setItem("externalDbs", JSON.stringify(targets));
    localStorage.removeItem("externalDb");
    setSaved(true);
  };

  return (
    <div style={{ padding: "6px" }}>
      <h3 style={{ margin: "0 0 8px" }}>Sync targets</h3>
      <p style={{ fontSize: "small", color: "#666", margin: "0 0 8px" }}>
        Changes take effect after page reload.
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {targets.map((t, i) => (
          <div key={i} style={{ display: "flex", gap: "4px" }}>
            <input
              type="text"
              placeholder="name"
              value={t.name}
              onChange={e => update(i, 'name', e.target.value)}
              style={{ width: "100px" }}
            />
            <input
              type="text"
              placeholder="http://user:pass@host/db"
              value={t.url}
              onChange={e => update(i, 'url', e.target.value)}
              style={{ flexGrow: 1, fontFamily: "monospace", fontSize: "small" }}
            />
            <button type="button" onClick={() => remove(i)}>Remove</button>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: "4px", marginTop: "8px", alignItems: "center" }}>
        <button type="button" onClick={add}>Add</button>
        <button type="button" onClick={save}>Save</button>
        {saved && <span style={{ color: "green", fontSize: "small" }}>Saved — reload to apply.</span>}
      </div>
    </div>
  );
};
